import { useContext } from 'react';
import { ReporteesContext, ReporteesContextType } from '../contexts/ReporteesContext';

export const useReportees = (): ReporteesContextType => {
  const context = useContext(ReporteesContext);

  return context;
};
